/**
 * General helpers for responsive code
 */
export default {
	computed: {
		shouldAutofocus () {
			const width = Math.max(window.screen.width, window.innerWidth || 0)

			return width > 768
		}
	}
}
